// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { minutesToSeconds as fn } from "../minutesToSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const minutesToSeconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default minutesToSeconds;
